import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import DashboardChartMapContainer from './components/DashboardChartMapContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStats }) {
  const returnSmsNotificationsData = () => {
    const data = _.get(totalStats, 'item.total_sms_notifications_per_status');
    return {
      label: 'SMS Notifications',
      total: _.get(totalStats, 'item.total', 0),
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'checking',
        },
        {
          label: 'Processing',
          value: _.get(data, 'PROCESSING', 0),
          borderClassName: 'waiting'
        },
        {
          label: 'Sent',
          value: _.get(data, 'SENT', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStats();
  }, []);

  return (
    <div className="container-fluid mb-3">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard
            data={returnSmsNotificationsData()}
            className="mb-2"
          />
        </div>
        <div className="col-8 pr-0">
          <DashboardChartMapContainer />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStats: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS}`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
